<template>
  <div>
    <ItemBadge :itemState="item.state" />
      <div v-for="v in item.variants" :key="v.id">
        <Variant :variant="v" :itemState="item.state" />
    </div>
  </div>
</template>
<script>
import Variant from "./Variant";
import ItemBadge from "./ItemBadge";
export default {
  name: "ItemFunctions",
  props: ["item"],
  components: {
    Variant,
    ItemBadge,
  },
};
</script>